import React, { useEffect, useState } from 'react';
import Modal from "react-bootstrap/Modal";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import OrderPrint from '../../components/factoryOrder/OrderPrint';
import DeleteModal from "../../components/common/DeleteModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import { CheckNull } from "../../utils/Validate";
import { CreateEntry, DeleteEntry, GetList, UpdateEntry } from "../../providers/dataProvider";
import FactoryOrderProductList from './FactoryOrderProductList';
import FactoryOrderProductSummary from './FactoryOrderProductSummary';
import FactoryOrderQuantityEntry from '../../components/factoryOrder/FactoryorderQuantityEntry/FactoryOrderQuantityEntry';

const FactoryOrderProduct = ({
    menuRights,
    values,
    currencyDetail,
    setValues,
    currencyList,
    setQuotUserEntry,
    quotUserEntry,
    handleSubmit,
    loading,
    orderProductTab,
    setOrderProductTab,
    factoryReleaseRecordId,
    refreshFactoryOrderData,
    refreshFactoryOrderMarkData,
    activeMainTab,
    factoryOrderRecord,
    selectedOrder,
    releaseForm,
    isFactoryOrderEditMode,
    handleDeliveryFromDateChange
}) => {
    const [orderProductCount, setOrderProductCount] = useState(0);
    const [rename, setRename] = useState(null);
    const [renameError, setRenameError] = useState(null);
    const [deleteShow, setDeleteShow] = useState({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false
    });
    const [actionMsg, setActionMsg] = useState(null);
    const [productionMsg, setProductionMsg] = useState(null);
    const [productionShow, setProductionShow] = useState(false);
    const [productionLoading, setProductionLoading] = useState(false);
    const [factoryApproval, setFactoryApproval] = useState(null);
    const [approvalDecisionMsg, setApprovalDecisionMsg] = useState(null);
    const [approvalSuccessShow, setApprovalSuccessShow] = useState(false);
    const [approvalRemarks, setApprovalRemarks] = useState("");
    const [showApprovalPopover, setShowApprovalPopover] = useState(false);
    const [showPendingPopover, setShowPendingPopover] = useState(false);
    const [pendingPopoverTarget, setPendingPopoverTarget] = useState(null);
    const [errorShow, setErrorShow] = useState({
        show: false,
        errorMessage: "",
    });

    const EditOrderQuantity = (item) => {
        setOrderProductTab({ tab: "editorderquantity", data: item });
    };

    const getOrderProductId = (item) => item?.orderProductId || item?.id;

    const updateProducts = (updater) => {
        setValues((prev) => ({
            ...prev,
            products: updater(prev?.products || []),
        }));
    };

    const getProductKeys = (item) => [
        item?.customerOrderProductId,
        item?.quoteProductId,
        item?.orderProductId,
        item?.id,
    ].filter((value) => value !== null && value !== undefined && value !== "");

    const isSameProduct = (left, right) =>
        getProductKeys(left).some((leftKey) =>
            getProductKeys(right).some((rightKey) => String(leftKey) === String(rightKey))
        );

    const handleProductDeliveryDateChange = (date, product) => {
        updateProducts((products) =>
            products.map((item) =>
                isSameProduct(item, product)
                    ? { ...item, requestedDeliveryDate: date }
                    : item
            )
        );
    };

    const ProductRename = (item) => {
        if (!getOrderProductId(item)) return;
        setRename({ ...item });
        setRenameError(null);
    };

    const updateMarkName = () => {
        if (!rename) return;
        const markName = rename?.markName?.trim();
        if (!markName) {
            setRenameError("Name is required");
            return;
        }

        const orderProductId = getOrderProductId(rename);
        const updatedProduct = { ...rename, id: orderProductId, markName };
        setRenameError(null);
        updateProducts((products) =>
            products.map((product) =>
                getOrderProductId(product) === orderProductId
                    ? { ...product, markName }
                    : product
            )
        );
        UpdateEntry(
            "updateorderproductmark",
            updatedProduct,
            setActionMsg,
            "Mark Name updated successfully",
            "Failed to update markName"
        );
        setRename(null);
    };

    const HandleRenameKeyDown = (event) => {
        if (event.key === "Enter") updateMarkName();
    };

    const factoryReleaseId = factoryReleaseRecordId || factoryOrderRecord?.id;
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    const currentIdentityId = userProfile?.identityId || localStorage.getItem("authidentity");
    const approvalData = factoryApproval?.data || factoryOrderRecord?.approval;
    const approvalStatus = String(approvalData?.status || "").toLowerCase();
    const isApprovalPending = approvalStatus === "pending";
    const isApprovalApproved = approvalStatus === "approved";
    const isFactoryOrderReleased = isApprovalApproved;
    const submittedApprovalStatuses = ["Pending", "Approved", "Rejected"];
    const hasApprovalRequest = Boolean(
        approvalData?.approvalRequestId ||
        submittedApprovalStatuses.includes(approvalData?.status)
    );
    const currentStep = approvalData?.steps?.find(
        (step) => Number(step?.levelNo) === Number(approvalData?.currentLevelNo)
    );
    const isActionableForCurrentUser =
        isApprovalPending &&
        currentStep?.assignees?.some(
            (assignee) =>
                String(assignee?.approverIdentityId) === String(currentIdentityId) &&
                assignee?.status === "Pending"
        );

    const fetchFactoryApproval = () => {
        if (factoryReleaseId) {
            GetList("factoryPendingRequest", { id: factoryReleaseId }, setFactoryApproval);
        }
    };

    const formatDateTime = (date) => {
        if (!date) return "-";
        const parsedDate = new Date(`${date}${String(date).endsWith("Z") ? "" : "Z"}`);
        if (Number.isNaN(parsedDate.getTime())) return "-";

        return parsedDate.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const createEntryAsync = (resource, payload, successMessage, failureMessage) =>
        new Promise((resolve) => {
            CreateEntry(
                resource,
                payload,
                (response) => resolve(response),
                successMessage,
                failureMessage
            );
        });

    const handleGenerateProduction = async () => {
        if (!factoryReleaseId || productionLoading) return;

        setProductionLoading(true);
        try {
            if (!hasApprovalRequest) {
                const approvalResponse = await createEntryAsync(
                    "factoryApprovalRequest",
                    { id: factoryReleaseId, remarks: "factoryOrder" },
                    "Request submitted successfully",
                    "Failed to submit request"
                );

                if (approvalResponse?.status !== 200) {
                    setErrorShow({
                        show: true,
                        errorMessage: approvalResponse?.successData || approvalResponse?.message || "Failed to submit request",
                    });
                    setProductionLoading(false);
                    return;
                }

                setFactoryApproval({ data: approvalResponse?.successData, message: "success" });
                fetchFactoryApproval();
                refreshFactoryOrderData && refreshFactoryOrderData(factoryReleaseId);
                window.dispatchEvent(new Event("approvalStatusChanged"));
            }

            CreateEntry(
                "factoryrelease",
                { factoryReleaseId },
                setProductionMsg,
                "Production batch generated successfully",
                "Failed to generate production batch"
            );
        } catch (error) {
            setProductionLoading(false);
            setErrorShow({
                show: true,
                errorMessage: error?.message || "Failed to release factory order",
            });
        }
    };

    const handleApprovalDecision = (isApproved) => {
        if (!factoryReleaseId) return;

        CreateEntry(
            "factoryApprovalDecision",
            {
                id: factoryReleaseId,
                isApproved,
                remarks: approvalRemarks,
            },
            setApprovalDecisionMsg,
            isApproved ? "Approved successfully" : "Rejected successfully",
            isApproved ? "Failed to approve" : "Failed to reject"
        );
        setApprovalRemarks("");
        setShowApprovalPopover(false);
    };

    const showPendingApprovalDetails = (event) => {
        setPendingPopoverTarget(event?.currentTarget || null);
        setShowPendingPopover(true);
        setShowApprovalPopover(false);
    };

    const renderPendingApprovalDetails = () => (
        <div className="pending">
            <div className="approved-wrapper">
                <div className="d-flex align-items-center gap-2">
                    <i className="fas fa-exclamation-circle mr-2"></i>
                    <h6>{approvalData?.status || "Pending"}</h6>
                </div>
                <hr />
                {approvalData?.steps?.length ? approvalData.steps.map((step) => (
                    <div key={step?.id || step?.levelNo} className="mt-2">
                        <strong>Level {step?.levelNo} - {step?.status}</strong>
                        {(step?.assignees || []).map((assignee) => (
                            <ol className="c-timeline m-0" key={assignee?.id || assignee?.approverIdentityId}>
                                <li className="c-timeline__item">
                                    <div className="c-timeline__content d-flex align-items-center" style={{paddingBottom: "1.1rem"}}>
                                        <i className="fas fa-user mr-2"></i>
                                        <p className="c-timeline__desc">{assignee?.approverName || "-"}</p>
                                    </div>
                                </li>
                                <li className="c-timeline__item">
                                    <div className="c-timeline__content d-flex align-items-center" style={{paddingBottom: "1.1rem"}}>
                                        <i className="fas fa-briefcase mr-2"></i>
                                        <p className="c-timeline__desc">{assignee?.approverRoleName || "-"}</p>
                                    </div>
                                </li>
                                <li className="c-timeline__item">
                                    <div className="c-timeline__content d-flex align-items-center" style={{paddingBottom: "1.1rem"}}>
                                        <i className="fas fa-clipboard mr-2"></i>
                                        <p className="c-timeline__desc">{assignee?.status || "-"}</p>
                                    </div>
                                </li>
                            </ol>
                        ))}
                    </div>
                )) : (
                    <p className="approval-empty-message">No approvers found</p>
                )}
            </div>
        </div>
    );

    useEffect(() => {
        if (actionMsg?.message === "Mark duplicated successfully" && actionMsg?.successData?.id) {
            const duplicateId = actionMsg.successData.id;
            updateProducts((products) =>
                products.map((product, index) =>
                    typeof product?.id === "string" && product.id.indexOf("copy-") === 0 && index === products.length - 1
                        ? { ...actionMsg.successData, id: duplicateId }
                        : product
                )
            );
        }
    }, [actionMsg]);

    useEffect(() => {
        if (!productionMsg) return;

        const statusCode = productionMsg?.statusCode ?? productionMsg?.status;
        const isSuccess = statusCode === 200 || statusCode === 201 || statusCode === 204;

        setProductionLoading(false);
        if (isSuccess) {
            setProductionShow(true);
        }
    }, [productionMsg]);

    useEffect(() => {
        fetchFactoryApproval();
    }, [factoryReleaseId]);

    useEffect(() => {
        if (CheckNull(approvalDecisionMsg?.message).includes("Failed")) {
            setErrorShow({
                show: true,
                errorMessage: approvalDecisionMsg?.successData,
            });
        } else if (CheckNull(approvalDecisionMsg?.status) == 200) {
            setApprovalSuccessShow(true);
            fetchFactoryApproval();
            refreshFactoryOrderData && refreshFactoryOrderData(factoryReleaseId);
            window.dispatchEvent(new Event("approvalStatusChanged"));
        }
    }, [approvalDecisionMsg]);

    return (
        <div
            className={`tab-pane fade${activeMainTab === "order-summary" ? " show active" : ""}`}
            id="pills-order-summary"
            role="tabpanel"
            aria-labelledby="pills-order-summary-tab"
        >
            {orderProductTab.tab === "editorderquantity" ? (
               <FactoryOrderQuantityEntry
                        setOrderProductTab={setOrderProductTab}
                        values={values}
                        setValues={setValues}
                        orderProductTab={orderProductTab}
                        currencyDetail={currencyDetail}
                        factoryReleaseRecordId={factoryReleaseRecordId}
                        refreshFactoryOrderMarkData={refreshFactoryOrderMarkData}
                        refreshFactoryOrderData={refreshFactoryOrderData}
                        factoryOrderRecord={factoryOrderRecord}
                        releaseForm={releaseForm}
                        isFactoryOrderEditMode={isFactoryOrderEditMode}
                        isFactoryOrderReleased={isFactoryOrderReleased}
                    />
            ) : (
                <>
                    <div className="row pt-1 product-configurations-row mt-2 order-product-manage">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="quote-product-actionbar order-product-actionbar">
                                <div>
                                    <span>Products</span>
                                    <strong>{orderProductCount} mark{orderProductCount === 1 ? "" : "s"}</strong>
                                </div>
                                <div className="d-flex">
                                    {isApprovalApproved ? (
                                    <div className="factory-order-btn">
                                        Factory order released
                                    </div>
                                    ) : isApprovalPending ? (
                                    <button
                                        type="button"
                                        className="factory-order-btn"
                                        onClick={showPendingApprovalDetails}
                                    >
                                        Awaiting approval
                                    </button>
                                    ) : (
                                    <div className="quote-product-actionbar-actions">
                                        {factoryReleaseId && isActionableForCurrentUser ? (
                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm mr-2"
                                                onClick={() => {
                                                    setShowApprovalPopover(true);
                                                    setShowPendingPopover(false);
                                                }}
                                            >
                                                Approve
                                            </button>
                                        ) : null}
                                        {factoryReleaseId && isApprovalPending ? (
                                            <button
                                                type="button"
                                                className="btn approval-request-btn mr-2"
                                                onClick={showPendingApprovalDetails}
                                            >
                                                Pending Approval
                                            </button>
                                        ) : null}
                                        {factoryReleaseId ? (
                                            <button
                                                type="button"
                                                className="btn update-btn"
                                                onClick={handleGenerateProduction}
                                                disabled={productionLoading}
                                                style={{color: '#fff', background: '#005795', borderColor: '#005795', height: '31px',borderRadius:'7px', padding: '3px', fontSize: '14px', width: '80px',marginRight:'7px'}}
                                            >
                                                {productionLoading ? "Generating..." : "Release"}
                                            </button>
                                        ) : null}
                                    </div>
                                    )}
                                    <div className="quote-product-actionbar-actions">
                                        {menuRights?.canPrint === true && (
                                            <OrderPrint
                                                values={{ ...values, id: factoryReleaseId, orderId: values?.id }}
                                                currencyDetail={currencyDetail}
                                            />                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="row quotation-summary-row order-summary-products-row">
                                <FactoryOrderProductList
                                    values={values}
                                    currencyDetail={currencyDetail}
                                    EditOrderQuantity={EditOrderQuantity}
                                    rename={rename}
                                    renameError={renameError}
                                    setOrderProductCount={setOrderProductCount}
                                    onRename={ProductRename}
                                    onRenameBlur={updateMarkName}
                                    onRenameChange={setRename}
                                    onRenameKeyDown={HandleRenameKeyDown}
                                    factoryOrderRecord={factoryOrderRecord}
                                    isFactoryOrderEdit={Boolean(factoryReleaseRecordId)}
                                     selectedOrder={selectedOrder}
                                    releaseForm={releaseForm}
                                    onProductDeliveryDateChange={handleProductDeliveryDateChange}
                                    approvalData={approvalData}
                                    showApprovalColumn={hasApprovalRequest}
                                    isFactoryOrderReleased={isFactoryOrderReleased}
                                    isActionableForCurrentUser={isActionableForCurrentUser}
                                    onActionableApproval={() => {
                                        setShowApprovalPopover(true);
                                        setShowPendingPopover(false);
                                    }}
                                    onApprovalIndicator={showPendingApprovalDetails}
                                />
                                <FactoryOrderProductSummary
                                    values={values}
                                    setValues={setValues}
                                    currencyDetail={currencyDetail}
                                    setQuotUserEntry={setQuotUserEntry}
                                    quotUserEntry={quotUserEntry}
                                    factoryOrderRecord={factoryOrderRecord}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
            <SaveSuccessModel
                show={productionShow}
                createMsg={productionMsg}
                setShow={setProductionShow}
                SuccessDoneClick={() => setProductionShow(false)}
            />
            <SaveSuccessModel
                show={approvalSuccessShow}
                createMsg={approvalDecisionMsg}
                setShow={setApprovalSuccessShow}
                SuccessDoneClick={() => setApprovalSuccessShow(false)}
            />
            <ErrorMessage
                Show={errorShow?.show}
                errorMessage={errorShow?.errorMessage}
                ErrorDoneClick={() => setErrorShow({ show: false, errorMessage: "" })}
            />
            <Modal
                show={showApprovalPopover}
                onHide={() => setShowApprovalPopover(false)}
                centered
                size="sm"
                className="approvalLevelsModal"
            >
                <Modal.Body>
                    <div className="approve-popover">
                        <h3>Approver Remarks</h3>
                        <hr />
                        <textarea
                            rows={4}
                            className="form-control mb-2"
                            placeholder="Enter your remarks here"
                            value={approvalRemarks}
                            onChange={(e) => setApprovalRemarks(e.target.value)}
                        />
                        <div className="mt-3 d-flex">
                            <button className="btn btn-sm btn-success w-100 mr-2" onClick={() => handleApprovalDecision(true)}>
                                Approve
                            </button>
                            <button className="btn btn-sm btn-danger w-100" onClick={() => handleApprovalDecision(false)}>
                                Reject
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Overlay
                show={showPendingPopover}
                onHide={() => setShowPendingPopover(false)}
                target={pendingPopoverTarget}
                placement="bottom-end"
                rootClose
            >
                <Popover className="factory-approval-callout">
                    <Popover.Body>{renderPendingApprovalDetails()}</Popover.Body>
                </Popover>
            </Overlay>
        </div>
    );
};

export default FactoryOrderProduct;
